var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { required, isValidRegex, grtrThanEqTo, lessThanEqTo, } from "@frameworks/salesjourney/utils/validation";
import { integerExp, alphaNumExp, whiteSpaceCheck, } from "@frameworks/salesjourney/utils/regex";
var InputField = function (props) {
    var _a, _b, _c;
    // sets the default value of input if present
    // value: value of the input (type = string)
    // setValue: function to set value
    var _d = __read(React.useState(props.defaultValue || ""), 2), value = _d[0], setValue = _d[1];
    // if default value is updated from outside, change it inside also
    React.useEffect(function () {
        if (props.defaultValue !== undefined && value !== props.defaultValue) {
            setValue(props.defaultValue);
        }
    }, [props.defaultValue]);
    // when focussed, this helps to colour the border of input_field_cont
    var _e = __read(React.useState(""), 2), focusClass = _e[0], setFocusClass = _e[1];
    var _f = __read(React.useState(false), 2), disablePaste = _f[0], setDisablePaste = _f[1];
    /**
     * @param value The string that needs to be checked for integer
     * @returns If integer need not be checked, then return true.
     * - If integer needs to be checked, then
     * - If value is valid integer, then return true; otherwise, return false
     */
    function isValidInteger(value) {
        return (!props.integer || (props.integer && !isValidRegex(value, integerExp)));
    }
    /**
     * @param value The string that needs to be checked for float
     * @returns If float need not be checked, then return true.
     * - If float needs to be checked, then
     * - if value is valid float, then return true; otherwise, return false
     */
    function isValidFloat(value) {
        return !props.float || (props.float && !isValidRegex(value, props.float));
    }
    /**
     * @param value The string that needs to be checked for alphanumeric characters
     * @returns If alphanum need not be checked, then return true.
     * - If alphanum needs to be checked, then
     * - if value is valid alphanum, then return true; otherwise, return false
     */
    function isValidAlphaNum(value) {
        return (!props.alphanum || (props.alphanum && !isValidRegex(value, alphaNumExp)));
    }
    /**
     * @param value The string that needs to be checked for maxlength
     * @returns If maxlength need not be checked, then return true.
     * - If maxlength needs to be checked, then
     * - if value has less characters than maxlength, then return true; otherwise, return false
     */
    function isValidMaxLength(value) {
        return props.maxLength === undefined || value.length <= props.maxLength;
    }
    /**
     * @param value The value that is required
     * @returns If required need not be checked, then return true.
     * - If required needs to be checked, return true if value is not present; false if value is present
     */
    function isRequired(value) {
        return !props.required || (props.required && !!required(value));
    }
    /**
     * @param value The value that is to be validated
     * @returns If min need not be checked, then return true.
     * - If min needs to be checked,
     * - throw error if value is string
     * - return true if value < min; false if value >= min
     */
    function isLessThanMin(value) {
        if (props.min === undefined) {
            return true;
        }
        if (isNaN(+value)) {
            throw Error("Can't validate non-numerical value for min");
        }
        return !!grtrThanEqTo(+value, props.min);
    }
    /**
     * @param value The value that is to be validated
     * @returns If max need not be checked, then return true.
     * - If max needs to be checked,
     * - throw error if value is string
     * - return true if value > max; false if value <= min
     */
    function isGrtrThanMax(value) {
        if (props.max === undefined) {
            return true;
        }
        if (isNaN(+value)) {
            throw Error("Can't validate non-numerical value for max");
        }
        return !!lessThanEqTo(+value, props.max);
    }
    /**
     * @param value The string that needs to be checked for the pattern
     * @returns If pattern need not be checked, then return true.
     * - If pattern needs to be checked, then
     * - if value is valid pattern, then return true; otherwise, return false
     */
    function isValidPattern(value) {
        return (!props.pattern || (props.pattern && !isValidRegex(value, props.pattern)));
    }
    /**
     * @param value input value gets checked with shouldBeDifferentValue-> True
     *  else false
     *  @returns true
     */
    function stringMatching(valueA, valueB) {
        console.log("valueA", valueA, valueB);
        return (!props.shouldBeDifferentValue ||
            (props.shouldBeDifferentValue && valueA === valueB));
    }
    function AvoidWhiteSpace(value) {
        return !(!props.AvoidWhiteSpace ||
            (props.AvoidWhiteSpace && !isValidRegex(value, whiteSpaceCheck)));
    }
    /**
     * This function runs on blur.
     * This removes the focus class on input_field_cont and removes commas.
     * This function calls the onBlur callback function with all the errors.
     */
    function handleBlur(e) {
        setFocusClass("");
        var errorObj = {};
        if (props.required) {
            errorObj = __assign(__assign({}, errorObj), { required: isRequired(value) }); // set isRequired error
        }
        if (props.min && !!Number(value)) {
            errorObj = __assign(__assign({}, errorObj), { min: isLessThanMin(value) }); // set error for min
        }
        if (props.max) {
            errorObj = __assign(__assign({}, errorObj), { max: isGrtrThanMax(value) }); // set error for max
        }
        if (props.pattern) {
            errorObj = __assign(__assign({}, errorObj), { pattern: isValidPattern(value) }); // set error for pattern
        }
        if (props.shouldBeDifferentValue) {
            errorObj = __assign(__assign({}, errorObj), { shouldBeDifferentValue: stringMatching(props.shouldBeDifferentValue, value) }); //set error for string match
        }
        if (props.AvoidWhiteSpace) {
            errorObj = __assign(__assign({}, errorObj), { hasWhiteSpace: AvoidWhiteSpace(value) }); // set error for pattern
        }
        props.onBlur && props.onBlur(errorObj, e);
    }
    /**
     * Checks for all the validations and then changes value accordingly
     * @param e The input event
     */
    function handleChange(e) {
        var _a, _b;
        if (disablePaste)
            setValue("");
        else {
            var resolvedValue = void 0;
            if (props.type == "password") {
                e.target.value = e.target.value.split(" ").join("");
            }
            if (!!(props === null || props === void 0 ? void 0 : props.toUpperCase) &&
                (props === null || props === void 0 ? void 0 : props.toUpperCase) &&
                !!e.target.value &&
                ((_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                e.target.value = e.target.value.toUpperCase();
            }
            if ((e.target.value || e.target.value === "" || e.target.value === "0") &&
                isValidInteger(e.target.value) &&
                isValidFloat(e.target.value) &&
                isValidAlphaNum(e.target.value) &&
                isValidMaxLength(e.target.value)) {
                // if value needs to be changed then process the new value
                resolvedValue = e.target.value;
            }
            else {
                // otherwise process the previous state
                resolvedValue = value;
            }
            if (props.hasOwnProperty("onChange")) {
                var newValue = props.onChange(resolvedValue || ""); // call onchange callback
                if (newValue !== undefined) {
                    setValue(newValue); // set the new value
                }
                else {
                    setValue(resolvedValue || ""); // set the new value
                }
            }
            else {
                setValue(e.target.value);
                props.onChangeEvent(e);
            }
        }
        setDisablePaste(false);
    }
    var handleMouseOut = function (e) {
        if (props.onMouseOut) {
            e.currentTarget.blur();
            props.onMouseOut(e.target.value);
        }
    };
    return (React.createElement("div", { className: "col", title: (props === null || props === void 0 ? void 0 : props.showTooltipOnhover) && value },
        React.createElement("div", { className: props.className },
            React.createElement("div", { className: (_a = props.placeholderClassName) !== null && _a !== void 0 ? _a : "" + (props.errorText ? " error" : focusClass) },
                value === "" && props.label && (React.createElement(React.Fragment, null,
                    React.createElement("label", { htmlFor: props.id }, props.placeholder),
                    props.required && React.createElement("span", { className: "star" }, "*"))),
                value != "" && props.showLabel && (React.createElement(React.Fragment, null,
                    React.createElement("label", { htmlFor: props.id }, props.placeholder))),
                (props === null || props === void 0 ? void 0 : props.showBothPlaceholderAndLabel) && (React.createElement(React.Fragment, null,
                    React.createElement("label", { htmlFor: props.id }, props === null || props === void 0 ? void 0 : props.inputLabel)))),
            props.prefix && React.createElement("div", { className: "input_prefix" }, props.prefix),
            React.createElement("input", __assign({ defaultValue: props.defaultValue ? props.defaultValue : value, value: value, onChange: handleChange, placeholder: props.label && !props.showBothPlaceholderAndLabel
                    ? ""
                    : props.placeholder, className: "form-control ".concat(props.highlightInputField && props.errorText && "RedBorder"), autoFocus: (_b = props === null || props === void 0 ? void 0 : props.autoFocus) !== null && _b !== void 0 ? _b : false, readOnly: (_c = props === null || props === void 0 ? void 0 : props.readOnly) !== null && _c !== void 0 ? _c : false, min: props === null || props === void 0 ? void 0 : props.min, name: props.name, onFocus: function () {
                    setFocusClass("focus");
                    if (props.onFocus) {
                        props.onFocus();
                    }
                }, onMouseOut: handleMouseOut, onBlur: function (e) { return handleBlur(e); }, type: props.type, id: props.id, disabled: props.disabled, autoComplete: props.autoComplete, onPaste: function () {
                    if (props.disablePaste)
                        setDisablePaste(true);
                }, required: props.required, inputMode: props.inputMode, pattern: props.inputPattern, onClick: function () { return props === null || props === void 0 ? void 0 : props.onClick; }, maxLength: props === null || props === void 0 ? void 0 : props.maxLength }, (props.onKeyDown ? { onKeyDown: function (e) { return props.onKeyDown(e); } } : {}), (props.onKeyPress
                ? { onKeyPress: function (e) { return props.onKeyPress(e); } }
                : {}), { ref: props === null || props === void 0 ? void 0 : props.inputRef })),
            props.children && props.children,
            props.suffix && React.createElement("div", { className: "input_suffix" }, props.suffix)),
        props.errorText && React.createElement("p", { className: "help_text red" }, props.errorText)));
};
export default InputField;
